import Vue from 'vue';

import {
  buscarOfertaAdesaoEmpresas,
  criar as criarOfertaCompra,
  deletar as deletarOfertaCompra,
  editAuction,
  get as dadosOfertaCompra,
  getElegiveisFechado as dadosElegiveisFechado,
  generateAuctionMinutes,
  getParticipantesFechado as dadosParticipantesFechado,
  getItens as dadosItens,
  encerrarAnalise,
  encerrarLances,
  encerrarHabilitacao,
  encerrarJulgamento,
  previewUndoAuctionItems as previewUndoAuctionItemsResource,
  undoAuctionItems as undoAuctionItemsResource,
  voltarParaAnaliseDePropostas,
  obterOpcoesVoltarEtapa as obterOpcoesVoltarEtapaResource,
  voltarEtapa as voltarEtapaResource,
  encerrarInterposicaoDeRecursos,
  encerrarOferta,
  openAuctionSession,
  publishAuction,
  reabrirSessao,
  exportAccountIntegration,
  stats as dadosStats,
} from '@/resources/ofertasCompra';

import { fetchItemsLastProposal } from '@/resources/electronicAuctions/proposals';

import {
  cancelAuction,
  changeSuspensionToSineDie,
  revokeAuction,
  suspendAuction,
  updateReopeningDate,
} from '@/resources/electronicAuctions/auctions';

import { types as typesItens } from './ofertasCompraItens';

const types = {
  OFERTAS_COMPRA: 'OFERTAS_COMPRA',
  OFERTAS_COMPRA_STATS_PREGAO: 'OFERTAS_COMPRA_STATS_PREGAO',
  OFERTAS_COMPRA_STATS_CONCORRENCIA: 'OFERTAS_COMPRA_STATS_CONCORRENCIA',
  OFERTAS_COMPRA_CARREGANDO: 'OFERTAS_COMPRA_CARREGANDO',
  OFERTA_COMPRA_EM_PUBLICACAO: 'OFERTA_COMPRA_EM_PUBLICACAO',
  OFERTAS_COMPRA_CLEAN: 'OFERTAS_COMPRA_CLEAN',
  OFERTAS_COMPRA_TOTAL: 'OFERTAS_COMPRA_TOTAL',
  OFERTAS_COMPRA_FILTRAR: 'OFERTAS_COMPRA_FILTRAR',
  OFERTAS_COMPRA_ALTERAR_POR_PAGINA: 'OFERTAS_COMPRA_ALTERAR_POR_PAGINA',
  OFERTA_COMPRA: 'OFERTA_COMPRA',
  OFERTA_COMPRA_ELEGIVEIS_FECHADO: 'OFERTA_COMPRA_ELEGIVEIS_FECHADO',
  OFERTA_COMPRA_PARTICIPANTES_FECHADO: 'OFERTA_COMPRA_PARTICIPANTES_FECHADO',
  OFERTA_COMPRA_ADESOES: 'OFERTA_COMPRA_ADESOES',
  OFERTA_COMPRA_ADICIONAR_ADESAO: 'OFERTA_COMPRA_ADICIONAR_ADESAO',
  OFERTA_COMPRA_STATUS: 'OFERTA_COMPRA_STATUS',
  OFERTA_COMPRA_LIMPAR: 'OFERTA_COMPRA_LIMPAR',
  OFERTA_COMPRA_LIMPAR_FILTROS: 'OFERTA_COMPRA_LIMPAR_FILTROS',
  OFERTA_COMPRA_UPDATE: 'OFERTA_COMPRA_UPDATE',
  OFERTA_COMPRA_ITENS: 'OFERTA_COMPRA_ITENS',
  OFERTA_COMPRA_ULTIMA_PROPOSTA_ITENS: 'OFERTA_COMPRA_ULTIMA_PROPOSTA_ITENS',
  OFERTAS_COMPRA_EXCLUIR: 'OFERTAS_COMPRA_EXCLUIR',
};

const mutations = {
  [types.OFERTAS_COMPRA](state, data) {
    if (data && Array.isArray(data)) {
      state.ofertasCompra = data;
      state.carregandoOfertasCompra = false;
    } else if (data && typeof data === 'object') {
      const index = state.ofertasCompra.findIndex(elemento => elemento.id === data.id);
      if (index > -1) {
        state.ofertasCompra[index] = Object.assign(state.ofertasCompra[index], data);
      }
    }
  },
  [types.OFERTAS_COMPRA_EXCLUIR](state, ofertaCompraId) {
    state.ofertasCompra = state.ofertasCompra.filter(
      ofertaCompra => ofertaCompra.id !== ofertaCompraId,
    );
  },
  [types.OFERTAS_COMPRA_CARREGANDO](state, data) {
    state.carregandoOfertasCompra = data;
  },
  [types.OFERTA_COMPRA_EM_PUBLICACAO](state, valor) {
    state.emPublicacao = valor;
  },
  [types.OFERTAS_COMPRA_STATS_PREGAO](state, { inProgress, missingValidations, suspended }) {
    state.stats.pregoes.inProgress = inProgress;
    state.stats.pregoes.missingValidations = missingValidations;
    state.stats.pregoes.suspended = suspended;
  },
  [types.OFERTAS_COMPRA_STATS_CONCORRENCIA](state, { inProgress, missingValidations, suspended }) {
    state.stats.concorrencias.inProgress = inProgress;
    state.stats.concorrencias.missingValidations = missingValidations;
    state.stats.concorrencias.suspended = suspended;
  },
  [types.OFERTAS_COMPRA_TOTAL](state, data) {
    state.total = Number(data);
  },
  [types.OFERTAS_COMPRA_FILTRAR](state, filters) {
    state.dataFilters = {
      ...state.dataFilters,
      page: 1,
      ...filters,
    };
  },

  [types.OFERTAS_COMPRA_ALTERAR_POR_PAGINA](state, perPage) {
    state.dataFilters.perPage = perPage;
    state.dataFilters.page = 1;
  },
  [types.OFERTA_COMPRA](state, data) {
    if (data && typeof data === 'object') {
      state.ofertaCompra = {
        ...state.ofertaCompra,
        ...data,
      };
      if (state.ofertaCompra.data_abertura) {
        state.ofertaCompra.data_abertura = new Date(state.ofertaCompra.data_abertura);
      }
      if (state.ofertaCompra.data_publicacao) {
        state.ofertaCompra.data_publicacao = new Date(state.ofertaCompra.data_publicacao);
      }
      if (state.ofertaCompra.data_final_entrega_propostas) {
        state.ofertaCompra.data_final_entrega_propostas = new Date(
          state.ofertaCompra.data_final_entrega_propostas,
        );
      }
      if (state.ofertaCompra.data_reabertura) {
        state.ofertaCompra.data_reabertura = new Date(state.ofertaCompra.data_reabertura);
      }
    }
  },
  [types.OFERTA_COMPRA_ELEGIVEIS_FECHADO](state, data) {
    if (data && Array.isArray(data)) {
      state.elegiveisFechado = data;
    } else if (data && typeof data === 'object') {
      const index = state.elegiveisFechado.findIndex(elemento => elemento.id === data.id);
      if (index > -1) {
        state.elegiveisFechado[index] = Object.assign(state.elegiveisFechado[index], data);
      }
    }
  },
  [types.OFERTA_COMPRA_PARTICIPANTES_FECHADO](state, data) {
    if (data && Array.isArray(data)) {
      state.participantesFechado = data;
    } else if (data && typeof data === 'object') {
      const index = state.participantesFechado.findIndex(elemento => elemento.id === data.id);
      if (index > -1) {
        state.participantesFechado[index] = Object.assign(state.participantesFechado[index], data);
      }
    }
  },
  [types.OFERTA_COMPRA_ADESOES](state, data) {
    if (data && Array.isArray(data)) {
      state.adesoes = data;
    } else if (data && typeof data === 'object') {
      const index = state.adesoes.findIndex(elemento => elemento.id === data.id);
      if (index > -1) {
        state.adesoes[index] = Object.assign(state.adesoes[index], data);
      } else {
        state.adesoes.push(data);
      }
    }
  },
  [types.OFERTA_COMPRA_ADICIONAR_ADESAO](state, data) {
    if (data && typeof data === 'object') {
      const index = state.adesoes.findIndex(
        elemento => elemento.itemId === data.itemId && elemento.fornecedorId === data.fornecedorId,
      );
      if (index > -1) {
        state.adesoes[index] = Object.assign(state.adesoes[index], data);
      } else {
        state.adesoes.push(data);
      }
    }
  },
  [types.OFERTA_COMPRA_STATUS](state, data) {
    if (data === 'PREFERENCIA') {
      state.ofertaCompra.status = data;
      state.ofertaCompra.situacao.id = 7;
      state.ofertaCompra.situacao.nome = 'Preferência';
    }
  },
  [types.OFERTA_COMPRA_LIMPAR](state) {
    state.ofertaCompra = {
      id: 0,
      tipo: '',
      comprador: {},
      tipo_negociacao: {},
      situacao: {},
      tipo_edital: '',
      tipo_pregao: '',
      modo_disputa: '',
      origem_recursos: [],
    };
  },
  [types.OFERTA_COMPRA_LIMPAR_FILTROS](state) {
    state.dataFilters = {
      buyerId: null,
      number: '',
      page: 1,
      perPage: state.dataFilters.perPage,
      period: {
        start: null,
        end: null,
      },
      situation: 'todas',
      purchasingUnitId: null,
    };
  },
  [types.OFERTA_COMPRA_UPDATE](state, data) {
    if (data && typeof data === 'object') {
      state.ofertaCompra = {
        ...state.ofertaCompra,
        ...data,
      };
    }
  },
  [types.OFERTA_COMPRA_ITENS](state, { ofertaCompraId, itens }) {
    if (itens && Array.isArray(itens)) {
      const indice = state.ofertasCompra.findIndex(
        ofertaCompra => ofertaCompra.id === ofertaCompraId,
      );
      if (indice > -1) {
        const novoObjeto = state.ofertasCompra[indice];
        novoObjeto.itens = itens;
        Vue.set(state.ofertasCompra, indice, novoObjeto);
      } else {
        state.ofertasCompra.push({
          id: ofertaCompraId,
          itens,
        });
      }
    }
  },
  [types.OFERTA_COMPRA_ULTIMA_PROPOSTA_ITENS](state, { ofertaCompraId, itens }) {
    if (itens && Array.isArray(itens)) {
      const indice = state.ofertasCompra.findIndex(
        ofertaCompra => ofertaCompra.id === ofertaCompraId,
      );
      if (indice > -1) {
        const itensOC = state.ofertasCompra[indice].itens;
        itens.forEach(item => {
          const index = itensOC.findIndex(itemOC => itemOC.id === item.id);

          if (index > -1) {
            const novoObjeto = state.ofertasCompra[indice].itens[index];
            novoObjeto.ultima_proposta = item.createdAt;
            Vue.set(state.ofertasCompra[indice].itens, index, novoObjeto);
          }
        });
      }
    }
  },
  [types.OFERTAS_COMPRA_CLEAN](state) {
    state.ofertasCompra = [];
  },
};

const actions = {
  async buscarOfertaCompra({ commit }, ofertaCompraId) {
    const response = await dadosOfertaCompra(ofertaCompraId);
    if (response.status !== 200) return Promise.reject(response);
    commit(types.OFERTA_COMPRA, response.data.data);
    return commit(types.OFERTAS_COMPRA_CARREGANDO, false);
  },
  async editAuction({ state, commit }, dados) {
    const auctionId = state.ofertaCompra.id;
    const auction = await editAuction(auctionId, dados);
    if (auction.status !== 200) return Promise.reject(auction.data.data);
    return commit(types.OFERTA_COMPRA, auction.data.data);
  },
  async publishAuction({ state, commit }) {
    const auctionId = state.ofertaCompra.id;
    const auction = await publishAuction(auctionId);
    if (auction.status !== 200) return Promise.reject(auction.data.data || auction.data);
    return commit(types.OFERTA_COMPRA, auction.data.data);
  },
  async openAuctionSession({ state, commit }) {
    const auctionId = state.ofertaCompra.id;
    const auction = await openAuctionSession(auctionId);
    if (auction.status !== 200) return Promise.reject(auction.data.data);
    return commit(types.OFERTA_COMPRA, auction.data.data);
  },
  async generateAuctionMinutes({ state }, data) {
    const auctionId = state.ofertaCompra.id;
    const ata = await generateAuctionMinutes(auctionId, data);
    if (ata.status !== 201) return Promise.reject(ata.data);
    return Promise.resolve(ata.data);
  },
  async buscarOfertaCompraElegiveisFechado({ commit, rootState }) {
    const ofertaCompraId = rootState.ofertasCompra.ofertaCompra.id;
    const { data: elegiveisFechado } = await dadosElegiveisFechado(ofertaCompraId);
    commit(types.OFERTA_COMPRA_ELEGIVEIS_FECHADO, elegiveisFechado.data);
  },
  async buscarOfertaCompraParticipantesFechado({ commit, rootState }) {
    const ofertaCompraId = rootState.ofertasCompra.ofertaCompra.id;
    const { data: participantesFechado } = await dadosParticipantesFechado(ofertaCompraId);
    commit(types.OFERTA_COMPRA_PARTICIPANTES_FECHADO, participantesFechado.data);
  },
  async buscarAdesoesPregao({ commit, rootState }) {
    const ofertaCompraId = rootState.ofertasCompra.ofertaCompra.id;
    const { data: adesoes } = await buscarOfertaAdesaoEmpresas(ofertaCompraId);
    commit(types.OFERTA_COMPRA_ADESOES, adesoes.data);
  },
  async cancelAuction({ commit }, { auctionId, justification }) {
    const response = await cancelAuction(auctionId, { justification });
    if (response.status !== 200) return Promise.reject(response.data);
    commit(types.OFERTA_COMPRA, response.data);
    return commit(types.OFERTAS_COMPRA, response.data);
  },
  async revokeAuction({ commit }, { auctionId, justification }) {
    const response = await revokeAuction(auctionId, { justification });
    if (response.status !== 200) return Promise.reject(response.data);
    commit(types.OFERTA_COMPRA, response.data);
    return commit(types.OFERTAS_COMPRA, response.data);
  },
  async suspendAuction({ commit }, { auctionId, justification, reopenDate, sineDie }) {
    const payload = sineDie ? { justification, sineDie: true } : { justification, reopenDate };
    const response = await suspendAuction(auctionId, payload);
    if (response.status !== 200) return Promise.reject(response.data);
    commit(types.OFERTA_COMPRA, response.data);
    return commit(types.OFERTAS_COMPRA, response.data);
  },
  async changeSuspensionToSineDie({ commit }, { auctionId, justification }) {
    const response = await changeSuspensionToSineDie(auctionId, { justification });
    if (response.status !== 200) return Promise.reject(response.data);
    commit(types.OFERTA_COMPRA, response.data);
    return commit(types.OFERTAS_COMPRA, response.data);
  },
  async updateReopeningDate({ commit }, { auctionId, reopeningDate }) {
    const response = await updateReopeningDate(auctionId, { reopeningDate });
    if (response.status !== 200) return Promise.reject(response.data);
    return commit(types.OFERTAS_COMPRA, response.data);
  },
  async encerrarAnalisePropostas({ commit, rootState }) {
    const ofertaCompraId = rootState.ofertasCompra.ofertaCompra.id;
    const response = await encerrarAnalise(ofertaCompraId);
    if (response.status !== 200) return Promise.reject(response);
    commit(types.OFERTA_COMPRA, response.data.oferta);
    return commit(typesItens.ITEM_UPDATE, response.data.itens);
  },
  async encerrarInterposicaoDeRecursos({ rootState }) {
    const ofertaCompraId = rootState.ofertasCompra.ofertaCompra.id;
    const response = await encerrarInterposicaoDeRecursos(ofertaCompraId);
    if (response.status !== 204) return Promise.reject(response);

    return ofertaCompraId;
  },
  async voltarParaAnaliseDePropostas({ commit, rootState }) {
    const ofertaCompraId = rootState.ofertasCompra.ofertaCompra.id;
    const response = await voltarParaAnaliseDePropostas(ofertaCompraId);
    if (response.status !== 200) return Promise.reject(response);
    commit(types.OFERTA_COMPRA, response.data.oferta);
    return commit(typesItens.ITEM_UPDATE, response.data.itens);
  },
  async obterOpcoesVoltarEtapa({ rootState }) {
    const ofertaCompraId = rootState.ofertasCompra.ofertaCompra.id;
    const response = await obterOpcoesVoltarEtapaResource(ofertaCompraId);
    if (response.status !== 200) return Promise.reject(response);
    return response.data;
  },
  async voltarEtapa({ commit, dispatch, rootState }, { destino, justificativa = '' }) {
    const ofertaCompraId = rootState.ofertasCompra.ofertaCompra.id;
    const response = await voltarEtapaResource(ofertaCompraId, {
      destino,
      justificativa,
    });
    if (response.status !== 200) return Promise.reject(response);
    commit(types.OFERTA_COMPRA, response.data.oferta);
    commit(typesItens.ITEM_UPDATE, response.data.itens);
    // Voltar etapa may clear adhesion selections server-side; refresh list so
    // the Adesões column does not keep stale websocket entries.
    await dispatch('buscarAdesoesPregao').catch(() => {
      commit(types.OFERTA_COMPRA_ADESOES, []);
    });
    return response.data;
  },
  async encerrarEtapaLances({ commit, rootState }) {
    const ofertaCompraId = rootState.ofertasCompra.ofertaCompra.id;
    const response = await encerrarLances(ofertaCompraId);
    if (response.status !== 200) return Promise.reject(response);
    commit(types.OFERTA_COMPRA, response.data.oferta);
    return commit(typesItens.ITEM_UPDATE, response.data.itens);
  },
  async encerrarEtapaHabilitacao({ commit, dispatch, rootState }) {
    const ofertaCompraId = rootState.ofertasCompra.ofertaCompra.id;
    const response = await encerrarHabilitacao(ofertaCompraId);
    if (response.status !== 200) return Promise.reject(response);
    commit(types.OFERTA_COMPRA, response.data.oferta);
    commit(typesItens.ITEM_UPDATE, response.data.itens);
    if (response.data?.oferta?.situacao?.id === 11) {
      await dispatch('buscarAdesoesPregao');
    }
    return response.data;
  },
  async encerrarEtapaJulgamento({ commit, rootState }) {
    const ofertaCompraId = rootState.ofertasCompra.ofertaCompra.id;
    const response = await encerrarJulgamento(ofertaCompraId);
    if (response.status !== 200) return Promise.reject(response);
    commit(types.OFERTA_COMPRA, response.data.oferta);
    return commit(typesItens.ITEM_UPDATE, response.data.itens);
  },
  async previewUndoAuctionItems({ rootState }, payload) {
    const ofertaCompraId = rootState.ofertasCompra.ofertaCompra.id;
    const itemIds = Array.isArray(payload) ? payload : payload?.itemIds || [];
    const targets = Array.isArray(payload) ? undefined : payload?.targets;
    const response = await previewUndoAuctionItemsResource(ofertaCompraId, itemIds, targets);
    if (response.status !== 200) return Promise.reject(response);
    return response.data;
  },
  async undoAuctionItems({ commit, dispatch, rootState }, { itemIds, justificativa, targets }) {
    const ofertaCompraId = rootState.ofertasCompra.ofertaCompra.id;
    const response = await undoAuctionItemsResource(ofertaCompraId, {
      itemIds,
      justificativa,
      targets,
    });
    if (response.status !== 200 || !response.data?.success) {
      return Promise.reject(response);
    }
    await dispatch('buscarItens', { ofertaCompraId });
    await dispatch('buscarAdesoesPregao').catch(() => {
      commit(types.OFERTA_COMPRA_ADESOES, []);
    });
    return response.data;
  },
  async excluirOfertaCompra({ commit }, ofertaCompraId) {
    const { status, data } = await deletarOfertaCompra(ofertaCompraId);
    if (status !== 204) {
      throw new Error(data.message);
    }
    commit(types.OFERTAS_COMPRA_EXCLUIR, ofertaCompraId);
  },
  async reabrirOfertaCompra({ commit }, ofertaCompraId) {
    const response = await reabrirSessao(ofertaCompraId);
    if (response.status !== 200) return Promise.reject(response);
    return commit(types.OFERTAS_COMPRA, response.data.data);
  },
  async encerrarPregao({ commit }, ofertaCompraId) {
    const response = await encerrarOferta(ofertaCompraId);
    if (response.status !== 200) return Promise.reject(response);
    return commit(types.OFERTAS_COMPRA, response.data.data);
  },
  async novaOfertaCompra({ commit }, tipo) {
    const ofertaCompra = await criarOfertaCompra(tipo);
    commit(types.OFERTA_COMPRA, ofertaCompra.data.data);
    return new Promise((resolve, reject) => {
      try {
        resolve(ofertaCompra.data.data.id);
      } catch (error) {
        reject(error);
      }
    });
  },
  validarOfertaCompra({ state }) {
    if (!state.ofertaCompra) return false;
    if (!state.ofertaCompra.comprador.cnpj) return false;
    if (!state.ofertaCompra.comprador.endereco) return false;
    if (!state.ofertaCompra.comprador.numero) return false;
    if (!state.ofertaCompra.comprador.bairro) return false;
    if (!state.ofertaCompra.comprador.municipio) return false;
    if (!state.ofertaCompra.comprador.uf) return false;
    if (!state.ofertaCompra.comprador.cep) return false;
    if (!state.ofertaCompra.comprador.nome) return false;
    if (!state.ofertaCompra.comprador.telefone) return false;
    if (!state.ofertaCompra.data_abertura) return false;
    if (!state.ofertaCompra.data_final_entrega_propostas) return false;
    if (!state.ofertaCompra.data_publicacao) return false;
    if (!state.ofertaCompra.endereco_entrega) return false;
    if (!state.ofertaCompra.endereco_entrega_numero) return false;
    if (!state.ofertaCompra.endereco_entrega_bairro) return false;
    if (!state.ofertaCompra.endereco_entrega_cep) return false;
    if (!state.ofertaCompra.endereco_entrega_municipio) return false;
    if (!state.ofertaCompra.endereco_entrega_uf) return false;
    if (!state.ofertaCompra.id) return false;
    if (!state.ofertaCompra.numero_oc) return false;
    if (!state.ofertaCompra.numero_processo) return false;
    if (!state.ofertaCompra.situacao || state.ofertaCompra.situacao.id < 1) {
      return false;
    }
    if (!state.ofertaCompra.estado) return false;
    if (!state.ofertaCompra.tipo_pregao) return false;
    if (!state.ofertaCompra.modo_disputa) return false;
    if (
      state.ofertaCompra.modo_disputa &&
      state.ofertaCompra.modo_disputa === 'COM_DISPUTA' &&
      !state.ofertaCompra.duracaoLances
    ) {
      return false;
    }
    if (!state.ofertaCompra.tipo_edital) return false;
    if (!state.ofertaCompra.objeto) return false;
    if (!state.ofertaCompra.tipo_negociacao || state.ofertaCompra.tipo_negociacao.id < 1) {
      return false;
    }
    if (!state.ofertaCompra.origem_recursos.length) return false;
    if (
      state.ofertaCompra.ano_instrumento &&
      (state.ofertaCompra.ano_instrumento < 1900 || state.ofertaCompra.ano_instrumento > 2099)
    ) {
      return false;
    }
    return true;
  },
  setOfertaCompraStatus({ commit }, data) {
    commit(types.OFERTA_COMPRA_STATUS, data);
  },
  limparPregao({ commit }) {
    commit(types.OFERTA_COMPRA_LIMPAR);
  },
  atualizarOfertaCompra({ commit }, data) {
    commit(types.OFERTA_COMPRA_UPDATE, data);
  },
  atualizarElegiveisFechado({ commit }, data) {
    commit(types.OFERTA_COMPRA_ELEGIVEIS_FECHADO, data);
  },
  atualizarParticipantesFechado({ commit }, data) {
    commit(types.OFERTA_COMPRA_PARTICIPANTES_FECHADO, data);
  },
  adicionarAdesaoPregao({ commit }, data) {
    commit(types.OFERTA_COMPRA_ADICIONAR_ADESAO, data);
  },
  alternarEmPublicacaoPregao({ commit }, valor) {
    commit(types.OFERTA_COMPRA_EM_PUBLICACAO, valor);
  },
  async buscarOfertaCompraItens({ commit }, ofertaCompraId) {
    const itens = await dadosItens(ofertaCompraId);
    commit(types.OFERTA_COMPRA_ITENS, {
      ofertaCompraId,
      itens: itens.data.data,
    });
  },
  async fetchItemsLastProposal({ commit }, ofertaCompraId) {
    const { data: itens } = await fetchItemsLastProposal(ofertaCompraId);
    commit(types.OFERTA_COMPRA_ULTIMA_PROPOSTA_ITENS, {
      ofertaCompraId,
      itens: itens.data,
    });
  },
  async exportAccountIntegration(_, ofertaCompraId) {
    const response = await exportAccountIntegration(ofertaCompraId);
    if (response.status !== 200) return Promise.reject(response);

    // Tratamento dos dados recebidos e estrutura de decisão para o tipo de exportação
    const { fileContent, fileType } = response.data;

    if (fileType === 'json') {
      // Fluxo específico para exportação como JSON
      const blob = new Blob([JSON.stringify(fileContent, null, 2)], {
        type: 'application/json',
      });

      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      const { fileName } = response.data;
      const now = new Date();
      const timestamp = now.toISOString().replace(/[-:]/g, '').replace('T', '-').slice(0, -5);

      link.download = fileName || `integracao-contabilidade-${timestamp}.json`;

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } else if (fileType === 'csv') {
      // 1. Extraímos os dados e as configurações (com fallbacks)
      const fornecedores = fileContent.fornecedores || [];
      const itens = fileContent.itens || [];
      const separator = fileContent.separator || '|';
      const printHeader = fileContent.printHeader || false;

      // Função auxiliar para transformar uma lista de objetos em linhas de texto
      const formatList = list => {
        if (list.length === 0) return [];
        // Identifica as colunas deste bloco específico
        const headers = [...new Set(list.flatMap(row => Object.keys(row)))];
        const regexSeparator = new RegExp(`\\${separator}`, 'g');

        const rows = list.map(row => {
          return headers
            .map(fieldName => {
              const value = row[fieldName];
              if (value === undefined || value === null) return '';
              // Remove quebras de linha e o separador atual do conteúdo
              return String(value)
                .replace(/[\r\n]+/g, ' ')
                .replace(regexSeparator, '-');
            })
            .join(separator);
        });

        // Se printHeader for true, inclui os cabeçalhos no topo deste bloco
        return printHeader ? [headers.join(separator), ...rows] : rows;
      };

      // 2. Processamos os dois blocos
      const corpoFornecedores = formatList(fornecedores);
      const corpoItens = formatList(itens);

      // 3. Unifica tudo em um único conteúdo, fornecedores primeiro
      const finalContent = [...corpoFornecedores, ...corpoItens].join('\r\n');

      // 4. Download do arquivo
      const blob = new Blob([finalContent], { type: 'text/plain;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = url;

      const { fileName } = response.data;
      const now = new Date();
      const timestamp = now.toISOString().replace(/[-:]/g, '').replace('T', '-').slice(0, -5);

      link.download = fileName || `integracao-contabilidade-${timestamp}.txt`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }

    return response;
  },
  async buscarStats({ commit }, type) {
    const response = await dadosStats(type);
    if (response.status !== 200) return Promise.reject(response);

    if (type === 'CONCORRENCIA') {
      return commit(types.OFERTAS_COMPRA_STATS_CONCORRENCIA, response.data);
    }
    return commit(types.OFERTAS_COMPRA_STATS_PREGAO, response.data);
  },
  cleanAuctions({ commit }) {
    commit(types.OFERTAS_COMPRA_CLEAN);
  },
};

const getters = {
  obterOfertaCompra(state) {
    return state.ofertaCompra;
  },
  obterElegiveisFechado(state) {
    return state.elegiveisFechado;
  },
  obterParticipantesFechado(state) {
    return state.participantesFechado;
  },
  obterOfertasCompra(state) {
    return state.ofertasCompra;
  },
  obterCarregandoOfertasCompra(state) {
    return state.carregandoOfertasCompra;
  },
  obterEmPublicacaoPregao(state) {
    return state.emPublicacao;
  },
  obterTotalOfertasCompra(state) {
    return state.total;
  },
  obterStatsConcorrencias(state) {
    return state.stats.concorrencias;
  },
  obterStatsPregoes(state) {
    return state.stats.pregoes;
  },
  obterDadosFiltros(state) {
    return state.dataFilters;
  },
  obterAdesoesPregao(state) {
    return state.adesoes;
  },
  isSineDieSuspended(state) {
    return (
      state.ofertaCompra?.situacao?.id === 17 && state.ofertaCompra?.suspensao_sine_die === true
    );
  },
  isSineDieFromEntregaDePropostas(state, moduleGetters) {
    return (
      moduleGetters.isSineDieSuspended && state.ofertaCompra?.situacao_id_antes_suspensao === 3
    );
  },
};

const state = {
  ofertaCompra: {
    id: 0,
    tipo: '',
    comprador: {},
    tipo_negociacao: {},
    situacao: {},
    tipo_edital: '',
    tipo_pregao: '',
    modo_disputa: '',
    origem_recursos: [],
  },
  elegiveisFechado: [],
  participantesFechado: [],
  adesoes: [],
  ofertasCompra: [],
  carregandoOfertasCompra: false,
  emPublicacao: false,
  total: 0,
  dataFilters: {
    buyerId: null,
    number: '',
    page: 1,
    perPage: 20,
    period: {
      start: null,
      end: null,
    },
    situation: 'todas',
    purchasingUnitId: null,
  },
  stats: {
    pregoes: {
      inProgress: 0,
      suspended: 0,
      missingValidations: 0,
    },
    concorrencias: {
      inProgress: 0,
      suspended: 0,
      missingValidations: 0,
    },
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};

export { types };
